/**
 * Card "Tenha mais controle da sua Conta de luz → Comparar planos" do Figma
 * (out/2026). Antes só existia no Dashboard vazio; agora aparece também com
 * imóveis cadastrados, para o DONO da conta fora do plano mais alto
 * (Enterprise). Membro de equipe não vê — plano é assunto do dono (o gate de
 * troca de plano está no backend, `isAccountOwner`). Reusa o visual do card
 * do Dashboard vazio.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';

import { useAppSelector } from 'store/hooks';
import * as selectUser from 'store/user/user.selector';
import { isAccountOwner } from 'entities/User';

import {
  EmptyPromoCard,
  EmptyPromoText,
  EmptyPromoButton,
} from '../../dashboard.styles';

const TOP_PLAN = 'Enterprise';

export const usePlanUpgradeVisible = (): boolean => {
  const currentUser = useAppSelector(selectUser.currentUser);
  return (
    !!currentUser &&
    isAccountOwner(currentUser) &&
    currentUser.plan?.name !== TOP_PLAN
  );
};

export const PlanUpgradeCard = () => {
  const navigate = useNavigate();

  return (
    <EmptyPromoCard>
      <EmptyPromoText>
        <p>Tenha mais controle da sua</p>
        <h2>Conta de luz</h2>
        <span>
          Faça o upgrade do seu plano Energypass e habilite o melhor que nós
          temos a oferecer.
        </span>
        <EmptyPromoButton onClick={() => navigate('/conta')}>
          Comparar planos <BsArrowRight />
        </EmptyPromoButton>
      </EmptyPromoText>
    </EmptyPromoCard>
  );
};
